import React, { useState } from 'react';
import { useClassName, useWindowSize } from 'common/hooks';
import { Button, Icon } from 'common/lazy';
import { MobileOnly, SVGIcon } from 'common/components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { MARKS } from '@contentful/rich-text-types';
import './tickets-cards.less';
import { usePagination } from 'public/screens/Home/Components/usePagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import NavigationControls from '../../NavigationControls/NavigationControls';
import CompareTickets from '../../CompareTickets/CompareTickets';
import { Link } from 'react-router-dom';

export const TicketsCards = ({ ticketsCards, tertiaryColor }) => {
  const className = useClassName('TicketsCards');
  const { isMobile } = useWindowSize();
  const pagination = usePagination({});
  const [swiperRef, setSwiperRef] = useState(null);
  const [hasMultipleSlides, setHasMultipleSlides] = useState(false);
  const [openCompareTickets, setOpenCompareTickets] = useState(false);

  const handleSwiperInit = (swiper) => {
    setSwiperRef(swiper);

    const bullets = swiper.pagination.bullets;
    setHasMultipleSlides(bullets.length > 1);
  };

  const handleSlidePrev = () => {
    swiperRef?.slidePrev();
  };

  const handleSlideNext = () => {
    swiperRef?.slideNext();
  };

  const handleOpenCompareTickets = () => {
    setOpenCompareTickets(true);
  };
  const handleCloseCompareTickets = () => {
    setOpenCompareTickets(false);
  };

  return (
    <div
      className={className('container')}
      style={{ background: tertiaryColor }}>
      <div className={className('inner')}>
        <Swiper
          {...pagination}
          modules={[Pagination]}
          centeredSlides={isMobile ? true : false}
          spaceBetween={32}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
            1128: {
              slidesPerView: 3,
            },
          }}
          speed={500}
          onSwiper={handleSwiperInit}
          preventClicksPropagation={true}
          className={className('carousel')}>
          {ticketsCards.slides.map((slide) => {
            const href = slide.link?.url ? slide.link?.url : '#';
            const target = slide.link?.type === 'external' ? '_blank' : '_self';

            return (
              <SwiperSlide key={slide.name} className={className('card')}>
                <Link to={href} target={target}>
                  <div className={className('card__asset')}>
                    <img
                      src={slide.asset.assetUrl}
                      alt={slide.asset.assetAlt}
                    />
                  </div>
                  <div className={className('card__content')}>
                    <h3 className={className('card__content__name')}>
                      {slide.name}
                    </h3>
                    <div className={className('card__content__days-info')}>
                      <Icon
                        name="calendar outline"
                        className={className('card__content__days-info__icon')}
                      />

                      <span>
                        {slide.daysInfo &&
                          documentToReactComponents(slide.daysInfo, {
                            renderMark: {
                              [MARKS.BOLD]: (text) => <strong>{text}</strong>,
                            },
                          })}
                      </span>
                    </div>
                    {slide.parkScreens?.length > 0 && (
                      <div className={className('card__content__park-screen')}>
                        <SVGIcon name="park-screen" size="tiny" />
                        <span>{slide.parkScreens?.join(', ')}</span>
                      </div>
                    )}
                    <p className={className('card__content__price')}>
                      {slide.useStartingAt && (
                        <span
                          className={className(
                            'card__content__price__starting-at'
                          )}>
                          {slide.useStartingAt}
                        </span>
                      )}
                      {slide.oldPrice && (
                        <span
                          className={className('card__content__price__old')}>
                          ${slide.oldPrice}
                        </span>
                      )}
                      <span
                        className={className('card__content__price__current')}>
                        {slide.price}
                      </span>
                    </p>
                  </div>
                  <Button
                    content={slide.link?.label || 'Get Passes'}
                    target={target}
                    className={className('card__button')}
                  />
                </Link>
              </SwiperSlide>
            );
          })}
        </Swiper>
        {hasMultipleSlides && !isMobile && (
          <NavigationControls
            onPrev={handleSlidePrev}
            onNext={handleSlideNext}
            disabledPrev={false}
            disabledNext={false}
          />
        )}
        <MobileOnly>
          <CompareTickets
            open={openCompareTickets}
            onClose={handleCloseCompareTickets}
            onOpen={handleOpenCompareTickets}
            ticketsCards={ticketsCards}
          />
        </MobileOnly>
      </div>
    </div>
  );
};
